
const ApiConstants = {
     contactUsUrl: 'api/bacode/contact-us',
     hiringUrl: 'api/bacode/hiring',
     fileStorageUrl: "api/file-storage/file-storage",
      jobListUrl:"api/bacode/job-list",
  };
  
  export default ApiConstants;
  